import { useAppActions } from 'reducers/slices/firebase/chatSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';
import { useSelector } from 'react-redux';

export default () => {
  const {
    getSignedUrl,
    sendMessage,
    loadAndSubscribeToChats,
    loadAndSubscribeToMessages,
    readMessages,
    subscribeToUsersOnlineStatuses,
    setChatFavorite,
    setChatHidden,
    changeSelectedChatUid,
    loadedChatsInfo,
    setNeedToSelectChat,
    authFirebase,
    setUserOnlineStatus,
    setOfflineStatusOnDisconnect,
    resetFirebase,
    setInitialized,
  } = useAppActions();
  const {
    chats,
    initialized,
    messages,
    subscribedChatMessagesUids,
    chatsLoadingStatus,
    usersOnlineStatusList,
    messagesLoadingStatus,
    needToLoadChatsInfo,
    selectedChatUid,
    needToSelectChat,
    firebaseAuthStatus,
    isOnline,
    onlineStatusSettingStatus,
  } = useSelector(state => state.firebaseChatSlice);

  return {
    sendMessage,
    setInitialized,
    initialized,
    getSignedUrl,
    readMessages,
    selectedChatUid,
    subscribedChatMessagesUids,
    subscribeToUsersOnlineStatuses,
    usersOnlineStatusList,
    loadAndSubscribeToMessages,
    changeSelectedChatUid,
    setChatFavorite,
    setChatHidden,
    chats,
    loadAndSubscribeToChats,
    messages,
    chatsLoadingStatus,
    isChatsLoaded: useFetchStatus(chatsLoadingStatus).isFulfilled,
    isChatsLoading: useFetchStatus(chatsLoadingStatus).isPending,
    isChatsIdle: useFetchStatus(chatsLoadingStatus).isIdle,
    messagesLoadingStatus,
    isMessagesLoaded: useFetchStatus(messagesLoadingStatus).isFulfilled,
    isMessagesLoading: useFetchStatus(messagesLoadingStatus).isPending,
    loadedChatsInfo,
    needToLoadChatsInfo,
    setNeedToSelectChat,
    needToSelectChat,
    authFirebase,
    setUserOnlineStatus,
    setOfflineStatusOnDisconnect,
    resetFirebase,
    onlineStatusSettingStatus,
    firebaseAuthStatus,
    isAuthenticatedOnFirebase: useFetchStatus(firebaseAuthStatus).isFulfilled,
    isOnline,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/firebase/useChat.js